

















import { Component, Mixins } from "vue-property-decorator";
import { Profile } from "@/models";
import ProfileEditor from "@/components/ProfileEditor.vue";

@Component({
  components: {
    ProfileEditor,
  },
})
export default class AdminProfileCreate extends Mixins() {
  profile: Profile = new Profile({});

  cancel() {
    this.$router.go(-1);
  }

  get saveDisabled() {
    return true;
  }

  protected onSaved(profile: Profile) {
    this.$router.push({
      name: "AdminProfileEdit",
      params: {
        id: profile.id,
      },
    });
  }
}
